import ISimulator from "./ISimulator";
import { Loft } from '../classes/Golfer';
import Fitter from '../classes/Fitter';
import AA_SL from '../classes/AaSl';
import SimulatorData from './SimulatorData';

const ipAddress = "ws://127.0.0.1:7890/SendShotData";

const TrackManAdjustments = {
    attackAngleNull_DLMultiplier: -.42,
    attackAngleNull_Modifier: -1.84,
    dynamicLoftNull_AAMultiplier: -1.07,
    dynamicLoftNull_Modifier: 3.56
}

export default class Foresight implements ISimulator {

    attackAngle?: Number;
    dynamicLoft?: Number;
    carryDistance?: Number;
    ballSpeed?: Number;
    clubSpeed?: Number;
    headSpeed?: Number;
    launchAngle?: Number;
    backspin?: Number;

    modelType = "foresight";
    
    getUrl = () => {
        return ipAddress;
    }

    //Foresight device doesn't need to make adjustments
    calculateAttackAngleShaftLean = (loft: Loft, shotType: string, attackAngle: number, dynamicLoft: number | undefined, isForGrindCalculations: boolean, useRounding = true, fitter?: Fitter) => {
        let newShaftLean = dynamicLoft !== undefined ? dynamicLoft : -999;
        let newAttackAngle = attackAngle !== undefined ? attackAngle : -999;

        //only adjust the values for internal grind calculations. For the grid, display the raw data
        //at least one of the values from TM needs to be valid to continue (otherwise TM sent us a bad reading and it will not be used in calculations)
        if (isForGrindCalculations && (attackAngle !== undefined || dynamicLoft !== undefined)) {

            if (attackAngle !== undefined) {
                newAttackAngle = attackAngle;
                //shaft lean = club loft - dynamic loft + adjustment
                if (dynamicLoft !== undefined) {
                    newShaftLean = Number(loft) - dynamicLoft;
                }

                //apply a normalization function based on the loft and shot type
                if (loft >= "54" && shotType == "Full") {
                    newAttackAngle += 0.5;
                    newShaftLean -= 0.5;
                }
                if (shotType == "Pitch") {
                    newAttackAngle += 1;
                    newShaftLean -= 1;
                }
                if (shotType == "Open Face") {
                    newAttackAngle -= 1;
                    newShaftLean += 1;
                }

                //now that both values have been calculated, if either one was undefined then calculate it's estimated value based on the other value
                //only do so if its for an internal calculation and  the fitter selected this option
                //        if (dynamicLoft === undefined && isForGrindCalculations && fitter && fitter.useEstimateDynamicLoft) {
                if (dynamicLoft === undefined && isForGrindCalculations) {
                    newShaftLean = newAttackAngle * TrackManAdjustments.dynamicLoftNull_AAMultiplier + TrackManAdjustments.dynamicLoftNull_Modifier;
                }
                if (attackAngle === undefined) {
                    newAttackAngle = newShaftLean * TrackManAdjustments.attackAngleNull_DLMultiplier + TrackManAdjustments.attackAngleNull_Modifier;
                }

                //boundary case, JS toFixed() rounds to -0 which looks weird to the user
                if (newAttackAngle.toFixed(0) === '-0') { newAttackAngle = 0 };
            }
        }
        return new AA_SL(newAttackAngle < -900 ? "--" : String(newAttackAngle.toFixed(0)), newShaftLean < -900 ? "--" : String(newShaftLean.toFixed(0)));
    };

    //UOM must be in English units to match the TrackMan device
    handlePayload(data: any) {
        let simData = new SimulatorData();
        if (data) {
            simData.Id = this.getValueOrDefault(data.BallLaunch.ShotNumber).toString() + (new Date().getTime().toString());
            //Foresight used 3.4+E20 to signify an undefined value
            simData.attackAngle = (data.ClubData.VerticalPathDeg > -100 && data.ClubData.VerticalPathDeg < 100) ? data.ClubData.VerticalPathDeg : undefined;
            simData.dynamicLoft = (data.ClubData.LoftDeg > -100 && data.ClubData.LoftDeg < 100) ? data.ClubData.LoftDeg : undefined;
                simData.clubSpeed = (data.ClubData.ClubSpeedMPH > -100 && data.ClubData.ClubSpeedMPH < 100) ? data.ClubData.ClubSpeedMPH : 0;
            //special test case b/c Jay's app send out junk data that it tough to test.
            if (simData.attackAngle?.toFixed(0) === "61") { simData.attackAngle = 6.1 };
                simData.ballSpeed = this.getValueOrDefault(data.BallLaunch.BallSpeedMPH || 0);
            simData.launchAngle = this.getValueOrDefault(data.BallLaunch.LaunchAngleDeg || 0);
            simData.backSpin = this.getValueOrDefault(data.SpinData.BackSpinRPM || 0);
            //use English units so it's compatible with TM data / calculations
            simData.clubSpeed = simData.clubSpeed / 2.237;
            simData.ballSpeed = simData.ballSpeed / 2.237;
            simData.carryDistance = 0;
        }
        return simData;
    }

    getValueOrDefault = (value: Number | undefined) => {
        if (value && Number(value)) {
            return Number(value);
        } else {
            return 0;
        }
    }

    isValidShotPayload = (data: any) => {
        let isValid = false;
        if (data) {
            if (data.ClubData && data.ClubData.VerticalPathDeg) {
                this.attackAngle = this.getValueOrDefault(data.ClubData.VerticalPathDeg);
                isValid = (data.ClubData.VerticalPathDeg && data.ClubData.VerticalPathDeg !== undefined);
            }
        }
        return isValid;
    }
}